import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as creditApi from '@/network/api/cards/credit.api.js'

/** requests Cards List
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
	const res = await cardsApi.cards(payload)

	if (res) {
		const data = res.data
		context.commit('SAVE_CARDS', data)
	}
	return res
}

/** requests Card Payments Methods List
@return {promise} - List of methods available
*/
export const requestMethods = async (context, payload) => {
	const res = await creditApi.getCreditCardPaymentsMethodsList(payload)

	if (res) { context.commit('SAVE_METHODS_LIST', res.data.data.methodPayments) }
	return res
}

/** updates Card Payment Method
@payload {Object}
@return {promise} - Updates card payment methods
*/
export const updateCardPaymentMethod = async (context, payload) => {
	const res = await creditApi.changeCreditCardPaymentsMethod(payload)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
